import { render, staticRenderFns } from "./BatchOperationsPlugin.vue?vue&type=template&id=51a21e82&"
import script from "./BatchOperationsPlugin.vue?vue&type=script&lang=ts&"
export * from "./BatchOperationsPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports